import { SharedSubFlowV1BlockFormFields } from './SharedFormFields';

export function SubFlowFormFields() {
  return <SharedSubFlowV1BlockFormFields fieldNamePrefix="config" />;
}
